import React from 'react';

// A small, reusable block to render a titled list of checkboxes or radios
// Uses the global cf-* classes from CoursesFilter.css for consistent styling
export type ChecBoxesBlockOption = {
  label: string;
  value: string;
};

export type ChecBoxesBlockProps = {
  id?: string; // id for aria-labelledby of the group
  title?: string; // optional title shown above the list
  type?: 'checkbox' | 'radio';
  name?: string; // required for radio groups
  options: ChecBoxesBlockOption[];
  // Selection: use `value` for radio, and `values` for checkbox
  value?: string; // selected value for radio
  values?: string[]; // selected values for checkboxes
  onChange: (next: string | string[]) => void;
  className?: string;
};

const CheckBoxesBlock: React.FC<ChecBoxesBlockProps> = ({
  id,
  title,
  type = 'checkbox',
  name,
  options,
  value,
  values,
  onChange,
  className,
}) => {
  const isRadio = type === 'radio';

  return (
    <div className={`cf-section${className ? ` ${className}` : ''}`} role={isRadio ? 'radiogroup' : 'group'} aria-labelledby={id}>
      {title ? (
        <div id={id} className="cf-section-title">{title}</div>
      ) : null}
      {options.map(opt => {
        const checked = isRadio
          ? value === opt.value
          : Array.isArray(values) && values.includes(opt.value);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          if (isRadio) {
            onChange(opt.value);
          } else {
            const cur = Array.isArray(values) ? values : [];
            const next = e.target.checked
              ? [...cur, opt.value]
              : cur.filter(v => v !== opt.value);
            onChange(next);
          }
        };

        return (
          <label key={opt.value} className="cf-checkbox">
            <input
              type={isRadio ? 'radio' : 'checkbox'}
              name={isRadio ? name : undefined}
              checked={!!checked}
              onChange={handleChange}
            />
            <span>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckBoxesBlock;
